import React from 'react';

import { iconBase } from '../utils';

import Input from './form/Input';
import Select from './form/Select';
import { MdDelete } from 'react-icons/md';

class AllocationsTable extends React.Component {
    static defaultProps = {
        product: null,
        templateSelect: true,
        allocations: [],
        onAllocChange: () => {}
    };

    constructor(props) {
        super(props);

        this.hasErrors = false;

        this.col_labels = {
            branch: 'Branch',
            collection: 'Collection',
            fund: 'Fund',
            holding_code: 'Holding Code',
            item_type: 'Item Type',
            location: 'Location'
        };

        this.base_allocation = {
            branch: null,
            collection: null,
            fund: null,
            holding_code: null,
            item_type: null,
            location: null,
            qty: 0
        };

        this.allocations = null;
        this.inputs = {};
        this.handleItemChange = this.handleItemChange.bind(this);
        this.handleAddRow = this.handleAddRow.bind(this);
        this.handleGridSelect = this.handleGridSelect.bind(this);
        this.handleClearAlloc = this.handleClearAlloc.bind(this);
    }

    handleAddRow(event) {
        event.preventDefault();
        let { product, cartId } = this.props;
        let sku = product && product.sku;
        this.props.onAllocChange(cartId, sku, [...this.allocations, this.base_allocation]);
    }

    handleClearAlloc(event) {
        event.preventDefault();
        let { product, cartId } = this.props;
        let sku = product && product.sku;
        this.props.onAllocChange(cartId, sku, []);
    }

    handleGridSelect(event) {
        let data = null;
        let { product, cartId, account } = this.props;
        let sku = product && product.sku;
        let value = event.currentTarget.value;

        if (value === '') {
            return false;
        }

        if (value === 'custom') {
            data = [this.base_allocation];
        }

        let userTemplate = account.grid.templates.find((tmpl) => tmpl._id === value);
        if (userTemplate) {
            data = userTemplate.rows;
        }

        if (!data) {
            return false;
        }

        this.props.onAllocChange(cartId, sku, data);
    }

    handleItemChange(event) {
        let { product, cartId } = this.props;
        let sku = product && product.sku;
        let data = [];

        for (let row in this.inputs) {
            let rowData = { ...this.base_allocation };
            for (let key in this.inputs[row]) {
                let rawValue = this.inputs[row][key].input.value;
                let value = key === 'qty' ? parseInt(rawValue, 10) : rawValue;
                rowData[key] = rawValue ? value : null;
            }

            data.push(rowData);
        }

        this.props.onAllocChange(cartId, sku, data);
    }

    render() {
        let { account, allocations, product, isReadOnly, templateSelect } = this.props;

        this.allocations = allocations;

        if (!this.allocations.length && templateSelect) {
            return (
                <div>
                    {isReadOnly ? (
                        <div className="a-right">No Grid Selected.</div>
                    ) : (
                        <section className="envalo_table form-inline l-text-right">
                            <label htmlFor={`template_select_${product.sku}`}>
                                Please choose a grid template to apply:
                            </label>{' '}
                            <select
                                name="template_select"
                                id={`template_select_${product.sku}`}
                                onChange={this.handleGridSelect}
                            >
                                <option value="">-- Select Grid Template--</option>
                                <option value="custom">** Custom Grid **</option>
                                {account.grid.templates.map((tmpl) => {
                                    let qty = 0;
                                    tmpl.rows.forEach((row) => (qty += row.qty));
                                    return (
                                        <option key={`tmpl_${tmpl._id}`} value={tmpl._id}>
                                            {tmpl.name} - ({tmpl.rows.length} rows, {qty} qty)
                                        </option>
                                    );
                                })}
                            </select>
                        </section>
                    )}
                </div>
            );
        }

        let cols = account.grid.columns.filter((col) => col.values.length);

        var allocTotal = 0;

        this.allocations.forEach((line) => {
            allocTotal += parseInt(line.qty, 10);
        });

        let errorMessage = <span>&nbsp;</span>;

        this.hasErrors = false;

        if (product && product.qty > allocTotal) {
            this.hasErrors = true;
            errorMessage = <span>You have under-allocated by {product.qty - allocTotal}</span>;
        } else if (product && allocTotal > product.qty) {
            this.hasErrors = true;
            errorMessage = <span>You have over-allocated by {allocTotal - product.qty}</span>;
        }

        this.rows = this.allocations.map((item, rowIndex) => {
            if (!this.inputs[rowIndex]) {
                this.inputs[rowIndex] = {};
            }
            return (
                <tr key={rowIndex}>
                    {cols.map((col, index) => {
                        var itemId = `${col.name}:${rowIndex}`;

                        return (
                            <td key={index}>
                                {isReadOnly ? (
                                    item[col.name] || '---'
                                ) : (
                                    <Select
                                        ref={(ref) => (this.inputs[rowIndex][col.name] = ref)}
                                        id={itemId}
                                        key={col.name}
                                        value={item[col.name]}
                                        onChange={this.handleItemChange}
                                    >
                                        <option value="">----</option>
                                        {col.values.map((value) => {
                                            return (
                                                <option key={value.code} value={value.code}>
                                                    {value.desc.trim() || value.code}
                                                </option>
                                            );
                                        })}
                                    </Select>
                                )}
                            </td>
                        );
                    })}
                    <td className="l-text-center">
                        {isReadOnly ? (
                            item.qty
                        ) : (
                            <Input
                                ref={(ref) => (this.inputs[rowIndex].qty = ref)}
                                id={'qty'}
                                type="number"
                                value={item.qty}
                                onChange={this.handleItemChange}
                                className="qty"
                            />
                        )}
                    </td>
                    {!isReadOnly && (
                        <td className="l-text-center">
                            <a href="#delete">
                                <MdDelete {...iconBase} />
                            </a>
                        </td>
                    )}
                </tr>
            );
        });

        return (
            <div>
                <div className="row-default">
                    <div className="lg-6">
                        <h5 className="table-title">Allocations</h5>
                    </div>

                    {!isReadOnly && (
                        <div className="lg-6 button-set l-text-right">
                            <button className="button-small button" onClick={this.handleAddRow}>
                                Add New Allocation
                            </button>
                            <button className="js-alloc-clear button-small button" onClick={this.handleClearAlloc}>
                                Clear Allocation
                            </button>
                        </div>
                    )}
                </div>
                <div className="envalo_table">
                    <table className="table">
                        <thead>
                            <tr>
                                {cols.map((col) => (
                                    <th key={`ils_column_${col.name}`} className="table-header">
                                        {this.col_labels[col.name]}
                                    </th>
                                ))}
                                <th className="l-text-center">Qty</th>
                                {!isReadOnly && <th className="l-text-center">Remove</th>}
                            </tr>
                        </thead>
                        <tbody>{this.rows}</tbody>
                    </table>
                    <div className="row-default f-align-center">
                        <div className="lg-9 text-danger">{errorMessage}</div>
                        <div className="lg-3">Total: {allocTotal}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AllocationsTable;
